import { Ship } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ShipmentEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="bg-white border border-slate-200 rounded-xl py-16 flex flex-col items-center gap-3 text-slate-400">
      <Ship size={32} strokeWidth={1.25} className="opacity-40" />
      <p className="text-[13px]">{t('shipments.empty')}</p>
    </div>
  );
}
